import React, { useState, useEffect, useContext } from "react";
import { Route, Link, useLocation } from "react-router-dom";
import Cookies from "js-cookie";

import { OBJECT_EMPTY, GET_TOKEN, GET_USER_LEVEL, SINGLE_PASSWORD_VALIDATION } from "../../helpers";
import { EXPECTED_COOKIES } from "../../helpers";
import { ContextOrders } from "../../Context/ContextOrders";
import { DashboardContent } from "./DashboardContent";
import { Modal } from "../Global/Modal/Modal";
import {
  API_URL,
  DASHBOARD_MENU,
  ADMIN_MENU,
  GET_NOTIFICATIONS_MENU,
  POST_USER_NEW_PASS,
} from "../../constants";

import "./Dashboard.css";

export const Dashboard = (props) => {
  const location = useLocation();

  const [notifications, setNotifications] = useState({});
  const [globalCurrency, setGlobalCurrency] = useState("EUR");
  const [globalDays, setGlobalDays] = useState("7");
  const [passwordError, setPasswordError] = useState('');
  const [passButtonDisabled, setPassButtonDisabled] = useState(true);
  const [modalPasswordFields, setModalPasswordFields] = useState({
    oldPass: '',
    newPass: '',
    confirmNewPass: '',
  });

  const ordersContext = useContext(ContextOrders);
  
  useEffect(() => {
    if (OBJECT_EMPTY(notifications)) {
      fetch(API_URL + GET_NOTIFICATIONS_MENU, {
        method: "GET",
        headers: new Headers({
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + GET_TOKEN(),
        }),
      })
        .then((response) => response.json())
        .then((response) => setNotifications(response))
    }
  }, [notifications]);

  // New pass disable
  useEffect(() => {
    if (modalPasswordFields.oldPass.length <= 0) return setPassButtonDisabled(true)
    if (modalPasswordFields.confirmNewPass !== modalPasswordFields.newPass) return setPassButtonDisabled(true)
    if (SINGLE_PASSWORD_VALIDATION(modalPasswordFields.newPass)) return setPassButtonDisabled(true)
    if (SINGLE_PASSWORD_VALIDATION(modalPasswordFields.confirmNewPass)) return setPassButtonDisabled(true)
    // password length 8

    setPassButtonDisabled(false);
  }, [modalPasswordFields])

  useEffect(() => {
    setPasswordError('')
  }, [modalPasswordFields])

  // clear values on user new pass modal
  useEffect(() => {
    setModalPasswordFields({
      oldPass: '',
      newPass: '',
      confirmNewPass: '',
    })
  }, [props.userNewPassword])


  const submitNewPassword = () => {
    const body = JSON.stringify({
      password_old: modalPasswordFields.oldPass,
      password: modalPasswordFields.confirmNewPass
    })

    fetch(API_URL + POST_USER_NEW_PASS, {
      method: "POST",
      headers: new Headers({
        "Content-Type": "application/json",
        Authorization: "Bearer " + GET_TOKEN(),
      }),
      body: body,
    })
    .then((response) => response.json())
    .then((response) => {

      response.error 
        ? setPasswordError(response.error)
        : props.setUserNewPassword(false);
    })
    .catch(error => console.log(error));
  };

  const listFields = () => {
    return GET_USER_LEVEL() < 4
      ? Object.entries(DASHBOARD_MENU).map(([fieldItem, fieldItemValue]) => {
        if (fieldItem === "userTypeTwoMenu" && GET_USER_LEVEL() == 1) {
          // eslint-disable-next-line
          return;
        }
  
        return (
          <ul className={"Dashboard__sidebar--" + fieldItem} key={fieldItem}>
            {fieldItemValue.map((item, index) => {  
              
              if (
                // Show only for admin
                item.id === "salesdetalization" && GET_USER_LEVEL() < 4 ||
                item.id === "adminvatrates" && GET_USER_LEVEL() < 4 ||
                item.id === "adminfileimport" && GET_USER_LEVEL() < 4 ||
                item.id === "profile" && GET_USER_LEVEL() < 4 ||
                item.id === "settings" && GET_USER_LEVEL() < 4 ||
                item.id === "returnsadmintable" && GET_USER_LEVEL() < 4 ||

                // only for lvl less than 4
                item.id === "returnsusertable" && GET_USER_LEVEL() >= 4 ||
                // item.id === "integrations" && GET_USER_LEVEL() >= 4 ||
                item.id === "documentation" && GET_USER_LEVEL() >= 4 ||
                item.id === "apilog" && GET_USER_LEVEL() >= 4 ||
                item.id === "returnsusercalendar" && GET_USER_LEVEL() >= 4 ||
  
                // only for lvl less than 3
                item.id === "userfileimport" && GET_USER_LEVEL() > 3
                ) {
                return;
              }
  
              return (
                <li
                  className={
                    "Dashboard__sidebar--" +
                    item.id +
                    " " +
                    ((`/dashboard/${item.id}` === location.pathname &&
                      " active") ||
                      "")
                  }
                  key={item.id}
                >
                  <Link to={"/dashboard/" + item.id} exact="true">
                    {
                      item.adminName && GET_USER_LEVEL() >= 4
                        ? <>{item.adminName}</>
                        : <>{item.name}</>
                    }
  
                    {item.id === "documentation" &&
                      notifications.counter &&
                      notifications.counter["documentation"] > 0 && (
                        <div className={"notification active"}>
                          {notifications.counter["documentation"]}
                        </div>
                      )}
  
                    {item.id === "apilog" &&
                      notifications.counter &&
                      notifications.counter["apilog"] > 0 && (
                        <div className={"notification active"}>
                          {notifications.counter["apilog"]}
                        </div>
                      )}
  
                    {item.id === "dashboard" &&
                      notifications.counter &&
                      notifications.counter["dashboard"] > 0 && (
                        <div className={"notification active"}>
                          {notifications.counter["dashboard"]}
                        </div>
                      )}
                  </Link>
                </li>
              );
            })}
          </ul>
        );
      })
      : Object.entries(ADMIN_MENU).map(([fieldItem, fieldItemValue]) => {
      if (fieldItem === "userTypeTwoMenu" && GET_USER_LEVEL() == 1) {
        // eslint-disable-next-line
        return;
      }

      return (
        <ul className={"Dashboard__sidebar--" + fieldItem} key={fieldItem}>
          {fieldItemValue.map((item, index) => {
            
            // if (
            //   // Show only for admin
            //   item.id === "salesdetalization" && GET_USER_LEVEL() < 4 ||
            //   item.id === "adminvatrates" && GET_USER_LEVEL() < 4 ||
            //   item.id === "adminfileimport" && GET_USER_LEVEL() < 4 ||
            //   item.id === "profile" && GET_USER_LEVEL() < 4 ||
            //   item.id === "settings" && GET_USER_LEVEL() < 4 ||
            //   item.id === "returnsadmintable" && GET_USER_LEVEL() < 4 ||
            //   // item.id === "orders" && GET_USER_LEVEL() == 4 ||
              
            //   // only for lvl less than 4
            //   item.id === "returnsusertable" && GET_USER_LEVEL() >= 4 ||
            //   item.id === "documentation" && GET_USER_LEVEL() >= 4 ||
            //   item.id === "apilog" && GET_USER_LEVEL() >= 4 ||
            //   // item.id === "returnsusercalendar" && GET_USER_LEVEL() >= 4 ||

            //   // only for lvl less than 3
            //   item.id === "userfileimport" && GET_USER_LEVEL() > 3
            //   ) {
            //   return;
            // }

            return (
              <li
                className={
                  "Dashboard__sidebar--" +
                  item.id +
                  " " +
                  ((`/dashboard/${item.id}` === location.pathname &&
                    " active") ||
                    "")
                }
                key={item.id}
              >
                <Link to={"/dashboard/" + item.id} exact="true">
                  {
                    item.adminName && GET_USER_LEVEL() >= 4
                      ? <>{item.adminName}</>
                      : <>{item.name}</>
                  }

                  {item.id === "orders" &&
                    ordersContext.ordersCount > 0 && (
                      <div className={"notification active"}>
                        {ordersContext.ordersCount}
                      </div>
                    )
                  }

                  {item.id === "documentation" &&
                    notifications.counter &&
                    notifications.counter["documentation"] > 0 && (
                      <div className={"notification active"}>
                        {notifications.counter["documentation"]}
                      </div>
                    )}

                  {item.id === "apilog" &&
                    notifications.counter &&
                    notifications.counter["apilog"] > 0 && (
                      <div className={"notification active"}>
                        {notifications.counter["apilog"]}
                      </div>
                    )}

                  {item.id === "dashboard" &&
                    notifications.counter &&
                    notifications.counter["dashboard"] > 0 && (
                      <div className={"notification active"}>
                        {notifications.counter["dashboard"]}
                      </div>
                    )}
                </Link>
              </li>
            );
          }
          )}
        </ul>
      );
      })
  };

  const changeGlobalCurrency = (value) => setGlobalCurrency(value);
  const changeGlobalDays = (value) => setGlobalDays(value);

  return (
    <div className="Dashboard">
      <div className="Dashboard__sidebar">{listFields()}</div>

      <Route
        name="userDashboardSection"
        path="/dashboard/:sectionType"
        key={4}
        render={(props) => {
          return (
            <DashboardContent
              {...props}
              globalCurrency={globalCurrency}
              changeGlobalCurrency={changeGlobalCurrency}
              globalDays={globalDays}
              changeGlobalDays={changeGlobalDays}
              key={props.match.params.type || "empty"}
            />
          );
        }}
      />

      <Modal
        ModalOpenHandler={props.setUserNewPassword}
        ModalOpen={props.userNewPassword}
        ModalBgCloseDisabled={true}
        customClassName={'modal__form_newemail'}
        title={'Please create new password'}
      >
        <input 
          type="password"
          placeholder='Current password'
          className='default-input'
          value={modalPasswordFields.oldPass}
          onChange={(e) => setModalPasswordFields({
            ...modalPasswordFields,
            oldPass: e.target.value
          })}
        />

        <input 
          type="password"
          placeholder='New Password'
          className='default-input'
          value={modalPasswordFields.newPass}
          onChange={(e) => setModalPasswordFields({
            ...modalPasswordFields,
            newPass: e.target.value
          })}
        />
        <p className="Input_helper">8+ characters, at least one number and letter</p>
        
        <input 
          type="password"
          placeholder='Confirm New Password'
          className='default-input'
          value={modalPasswordFields.confirmNewPass}
          onChange={(e) => setModalPasswordFields({
            ...modalPasswordFields,
            confirmNewPass: e.target.value
          })}
        />

        {passwordError && <p className="error-message">{passwordError}</p>}

        <div className="Modal__submit-wrapper">
          <button 
            onClick={submitNewPassword}
            disabled={passButtonDisabled}
          >
            submit
          </button>
        </div>
      </Modal>
    </div>
  );
};
